import { Edit as EditIcon, FormatListBulleted, NoteAdd as NoteAddIcon } from '@mui/icons-material';
import { SxProps } from '@mui/material';
import { NestedMenuItem } from 'mui-nested-menu';
import ActionButton from 'src/components/ActionButton';
import { WrappedServiceRequest } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/ServiceRequest';

interface ServiceRequestActionMenuProps {
  serviceRequest: WrappedServiceRequest | null | undefined;
  canEdit: boolean;
  canAddTask: boolean;
  labels: {
    notes: string;
    edit: string;
    task: string;
  };
  onNotesOpen: () => void;
  onEdit: () => void;
  onAddTask: () => void;
}

const nestedMenuItemStyles: SxProps = {
  paddingX: 3,
};

export default function ServiceRequestActionMenu({
  serviceRequest: _serviceRequest,
  canEdit,
  canAddTask,
  labels,
  onNotesOpen,
  onEdit,
  onAddTask,
}: ServiceRequestActionMenuProps) {
  return (
    <ActionButton
      renderChildren={(isMenuOpen, setIsMenuOpen) => (
        <>
          <NestedMenuItem
            sx={nestedMenuItemStyles}
            onClick={() => {
              onNotesOpen();
              setIsMenuOpen(false);
            }}
            leftIcon={<NoteAddIcon />}
            rightIcon={null}
            label={labels.notes}
            parentMenuOpen={isMenuOpen}
          />
          {canEdit ? (
            <NestedMenuItem
              sx={nestedMenuItemStyles}
              onClick={() => {
                onEdit();
                setIsMenuOpen(false);
              }}
              leftIcon={<EditIcon />}
              rightIcon={null}
              label={labels.edit}
              parentMenuOpen={isMenuOpen}
            />
          ) : null}
          {canAddTask ? (
            <NestedMenuItem
              sx={nestedMenuItemStyles}
              onClick={() => {
                onAddTask();
                setIsMenuOpen(false);
              }}
              leftIcon={<FormatListBulleted />}
              rightIcon={null}
              label={labels.task}
              parentMenuOpen={isMenuOpen}
            />
          ) : null}
        </>
      )}
    />
  );
}
